<template>
  <v-layout row wrap :class="['news-ticker']" align-space-between fill-height>
    <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
      <carousel :autoplay-timeout="autoplayTimeout" :pagination-active-color="$config.colors.hex" :per-page="perPage" autoplay autoplay-hover-pause v-if="posts && posts.length">
        <slide v-for="(post, index) in posts" :key="index" :class="['elevation-12']">
          <v-card @click.capture="gtagEvent('click', 'news-ticker', post.title.rendered)" :to="`/blog/${post.slug}`" :title="$lang.continueReading(post.title.rendered)" :class="['full-height']">
            <v-card-title :class="['py-0', 'pr-2']">
              <div v-html="$lang.latestNews(post.title.rendered)" />
              <v-spacer />
              <v-btn flat icon dark :class="['mr-0']" to="/blog" :title="$lang.blog" aria-label="to-all-videos">
                <v-icon>mdi-book-open-page-variant</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text v-html="post.excerpt.rendered" />
          </v-card>
        </slide>
      </carousel>
    </v-flex>
  </v-layout>
</template>
<script>
import methods from '../mixins/methods'

import {
  Slide,
  Carousel
} from 'vue-carousel'

export default {
  name: 'NewsTicker',
  mixins: [
    methods
  ],
  components: {
    Slide,
    Carousel
  },
  props: {
    perPage: {
      type: Number,
      default: 1
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    autoplayHoverPause: {
      type: Boolean,
      default: true
    },
    paginationActiveColor: {
      type: String,
      default: '#000'
    },
    paginationColor: {
      type: String,
      default: '#efefef'
    },
    autoplayTimeout: {
      type: Number,
      default: 5000
    }
  },
  data () {
    return {
      posts: []
    }
  },
  mounted () {
    this.getPosts()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/news-ticker.vue